import utils from '../utils/utils'
export default {
    userInfo: (state) => {
        return state.userInfo['name'] ? state.userInfo : utils.getStorage('userInfo') || {}
    }
}